import request from 'lib/request';

interface Response {
  code: number;
  msg: string;
  data?: null;
}

interface Params {
  raffle_win?: number;
  project_mint?: number;
}

export async function subscribeNotification(params: Params) {
  const res = await request<Response>('/user_profile/subscribe_notification', {
    method: 'POST',
    data: params,
  });
  return res;
}
